import { debounce } from '../../../scripts/utils/debounce';
import initButtons, { initDoofinderButtons } from '../../../sections/wishlist/scripts';
import initSwiper from '../../swiper';

if (!customElements.get('connected-products')) {
  class ConnectedProducts extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      if (!this.el) return;

      this.colorPlaceholder = this.el.querySelector('[data-color-placeholder]');
      this.swatches = this.el.querySelectorAll('.swiper-slide:not(button)');
      this.mainSwatch = this.el.querySelector('.swiper-slide.active');
      this.productId = this.mainSwatch.getAttribute('data-connected-product-id');
      this.mainProductHandle = this.el.dataset.mainProductHandle;
      this.productCard = this.el.closest('.product-card');
      this.cachedProductData = {};

      if (this.el.dataset.useJavascript == 'true') {
        this.useJavascript = true;
        this.getConnectedProductsHtml(this.mainProductHandle);
      } else {
        this.addSwatchEvents();
      }

      this.isGrid = this.el.hasAttribute('data-is-grid');
      if (this.isGrid) {
        this.showMoreButton = this.el.querySelector('#show-more-connected-products');
        if (this.showMoreButton) {
          if (this.swatches && this.swatches.length > 5) {
            const mq = window.matchMedia('(min-width: 768px)');
            this.hideExtraSwatches(mq);
            mq.addEventListener('change', this.hideExtraSwatches.bind(this));

            this.showMoreButton.addEventListener('click', this.showMore.bind(this));
          } else {
            this.showMoreButton.remove();
          }
        }
      }
    }

    hideExtraSwatches(mq) {
      let extraSwatchCount = 0;
      this.swatches.forEach((swatch, index) => {
        swatch.classList.remove('!hidden');
        if (mq.matches) {
          if (index > 4) {
            extraSwatchCount++;
            swatch.classList.add('!hidden');
          }
        } else {
          if (index > 3) {
            extraSwatchCount++;
            swatch.classList.add('!hidden');
          }
        }
      });

      this.showMoreButton.innerHTML = `+${extraSwatchCount}`;
    }

    showMore() {
      this.showMoreButton?.remove();
      this.swatches.forEach((swatch) => {
        swatch.classList.remove('!hidden');
      });
    }

    onProductCardHover(productCard) {
      if (!productCard) return;

      const images = productCard.querySelectorAll('connected-products img');
      if (images) images.forEach((image) => (image.src = image.getAttribute('data-src')));
      this.classList.remove('invisible');
    }

    onhover(swatch) {
      if (!swatch) return;

      this.swatches.forEach((swatch) => {
        swatch.classList.remove('active');
      });

      const color = swatch.getAttribute('data-color');
      if (this.colorPlaceholder) this.colorPlaceholder.innerHTML = color;

      swatch.classList.add('active');

      const mq = window.matchMedia('(min-width: 768px)');
      if (mq.matches) {
        this.connectedProductId = swatch.getAttribute('data-connected-product-id');

        const matchProduct = this.getProductData().find((product) => product.id.toString() === this.connectedProductId);
        if (matchProduct) {
          const html = matchProduct.html;
          this.renderProduct(html);
        }
      }
    }

    async getConnectedProductsHtml(handle) {
      let fetchedConnectedProducts = null;
      if (this.cachedProductData[handle]) {
        fetchedConnectedProducts = this.cachedProductData[handle];
      } else {
        const connectedProductHref = `${window.routes.root_url}products/${handle}?view=connected-products`;
        const resp = await fetch(connectedProductHref, {
          headers: {
            'Content-Type': 'application/json',
          },
        });
        const responseText = await resp.text();
        const respDOM = new DOMParser().parseFromString(responseText, 'text/html');
        fetchedConnectedProducts = respDOM.querySelector('connected-products').cloneNode(true);
        this.cachedProductData[handle] = fetchedConnectedProducts;
      }

      this.el.innerHTML = fetchedConnectedProducts.innerHTML;

      // reassign class variables as they refer to previous connected products that were replaced
      this.swatches = this.el.querySelectorAll('.swiper-slide');
      this.mainSwatch = this.el.querySelector('.swiper-slide.active');
      this.productId = this.mainSwatch.getAttribute('data-connected-product-id');
      this.swiperEl = this.el.querySelector('.swiper');

      initSwiper(this.swiperEl);
      this.addSwatchEvents();
    }

    addSwatchEvents() {
      let cardHover = false;
      if (this.productCard) {
        this.productCard.addEventListener(
          'mouseenter',
          debounce(() => {
            if (!cardHover) {
              this.onProductCardHover(this.productCard);
              cardHover = true;
            }
          }, 10).bind(this)
        );
        this.productCard.addEventListener(
          'mouseleave',
          debounce(() => {
            if (cardHover) {
              this.el.classList.add('invisible');
              cardHover = false;
            }
          }, 10).bind(this)
        );
      } else {
        const images = this.el.querySelectorAll('img');
        if (images) images.forEach((image) => (image.src = image.getAttribute('data-src')));
        this.el.classList.remove('invisible');
      }

      this.swatches.forEach((swatch) => {
        swatch.addEventListener(
          'mouseenter',
          debounce(() => {
            this.onhover(swatch);
          }, 100).bind(this)
        );
      });
      this.el.addEventListener(
        'mouseleave',
        debounce(() => {
          this.onhover(this.mainSwatch);
        }, 100).bind(this)
      );
    }

    getProductData() {
      this.productData = this.productData || JSON.parse(this.el.querySelector('[type="application/json"]').textContent);
      return this.productData;
    }

    renderProduct(html) {
      const destination = this.el.closest(`#CardWrapper-${this.productId}`);
      const parsedHtml = new DOMParser().parseFromString(html, 'text/html');
      const source = parsedHtml.querySelector(`#CardWrapper-${this.connectedProductId}`);
      if (!destination || !source) return;

      const elementsToReplace = ['.product-card-image-wrapper', '.product-card-main-info', '.product-card-price-wrapper', '.product-card-vendor-wrapper'];

      elementsToReplace.forEach((selector) => {
        const sourceElement = source.querySelector(selector);
        const destinationElement = destination.querySelector(selector);
        if (destinationElement && sourceElement) {
          destinationElement.innerHTML = sourceElement.innerHTML;
        }
      });
    }
  }
  customElements.define('connected-products', ConnectedProducts);
}

['related-products:loaded', 'shopify-wishlist:init-product-grid', 'product-grid:replaced'].forEach((event) => {
  document.addEventListener(event, () => {
    initButtons();
    initSwiper();
  });
});

document.addEventListener('search:update', function (e) {
  initDoofinderButtons();
});
